<!--
 * @message: 延禧秘传
 * @Author: cjc
 * @since: 2019-11-26 12:10:14
 * @lastTime     : 2019-12-19 11:14:35
 * @LastAuthor   : cjc
 -->
<template>
  <div id="index">
      <order-section></order-section>
      <role-swiper></role-swiper>
      <intro-swiper></intro-swiper>
    <floating-box ref="google"></floating-box>
    <a @click="scrollTop" class="btn goto"></a>
  </div>
</template>

<script>
import Order from './section/order'
import FloatingBox from '@/components/floatingBox'

export default {
  name: 'index',
  data () {
    return {}
  },
  methods: {
    scrollTop () {
      let timer = setInterval(function () {
        let osTop = document.documentElement.scrollTop || document.body.scrollTop
        let speed = Math.floor(osTop / 8) > 10 ? Math.floor(osTop / 8) : 10
        document.documentElement.scrollTop = document.body.scrollTop = osTop - speed
        if (osTop === 0) {
          clearInterval(timer)
        }
      }, 20)
    }
  },
  components: {
    [Order.name]: Order,
    [FloatingBox.name]: FloatingBox,
    'role-swiper': () => import('./section/role'),
    'intro-swiper': () => import('./section/intro')
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/mixins.scss';
@import '../assets/styles/variable.scss';

#index {
  .goto {
  @include p-fixed(70%, 0, top, right);
  @include setIndex($fixed-layer);
}
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue